import script from "./PerSalesman.vue?vue&type=script&setup=true&lang=js"
export * from "./PerSalesman.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__